<h2 mat-dialog-title>{{ 'REVIEW_HISTORY_CARD.TITLE' | translate }}</h2>
<mat-dialog-content>
  <div *ngIf="state$ | async as state">
    <ng-container *ngIf="!state.loading; else loading">
      <ng-container *ngIf="state.reviewHistory as reviewHistoryList; else empty">
        <div class="review">
          <div class="review-date">
            {{ review.reviewerName }} - {{ review.edited | glxyDate : DateFormat.longDate }}
            <glxy-badge [color]="'blue'" [size]="'small'" class="live-badge">
              {{ 'REVIEW_HISTORY_CARD.LIVE_BADGE' | translate }}
            </glxy-badge>
          </div>
          <div *ngIf="!review.recommendation">
            <mat-icon [ngClass]="star ? 'star-lit' : 'star'" *ngFor="let star of reviewStars">star</mat-icon>
          </div>
          <div class="review-content">{{ review.content }}</div>
        </div>
        <div *ngFor="let reviewHistoryWithStars of reviewHistoryList" class="review">
          <div class="review-date">
            {{ reviewHistoryWithStars.reviewHistory.reviewerName }} -
            {{ reviewHistoryWithStars.reviewHistory.published | glxyDate : DateFormat.longDate }}
          </div>
          <div *ngIf="!review.recommendation">
            <mat-icon [ngClass]="star ? 'star-lit' : 'star'" *ngFor="let star of reviewHistoryWithStars.stars">
              star
            </mat-icon>
          </div>
          <div class="review-content">{{ reviewHistoryWithStars.reviewHistory.content }}</div>
        </div>
      </ng-container>
      <ng-template #empty>
        <glxy-empty-state>
          <glxy-empty-state-hero>
            <img [src]="emptyImagePath" alt="No review history" />
          </glxy-empty-state-hero>
          <glxy-empty-state-title>{{ 'REVIEW_HISTORY_CARD.EMPTY_STATE.TITLE' | translate }}</glxy-empty-state-title>
          <p>{{ 'REVIEW_HISTORY_CARD.EMPTY_STATE.SUBTITLE' | translate }}</p>
        </glxy-empty-state>
      </ng-template>
    </ng-container>
    <ng-template #loading>
      <glxy-loading-spinner></glxy-loading-spinner>
    </ng-template>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close color="primary">
    {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
